import { CountryEntity, CurrencyType } from 'api/types/entity';
import { string, object, array, mixed, TypedForm } from 'libs/form';
import { Maybe } from 'types/maybe';

import { localFileScheme } from '../helpers/localFile';
import { LocalFileEntity } from '../types';

export interface WithdrawalAccountFormType {
  bankCountry: Maybe<CountryEntity>;
  swiftCode: string;
  bankName: string;
  bankAddress: string;
  checkingAccount: string;
  correspondentBankAccountNumber?: Maybe<string>;
  correspondentBankSwiftCode?: Maybe<string>;
  correspondentBankName?: Maybe<string>;
  currency: Maybe<{ value: CurrencyType; label: string }>;
  ownerConfirmationFiles: LocalFileEntity[];
}

export const withdrawalAccountSchema = object({
  swiftCode: string().required().max(200),
  bankName: string().required().max(200),
  bankAddress: string().required().max(200),
  checkingAccount: string().required().max(200),
  correspondentBankAccountNumber: string().nullable().optional().max(200),
  correspondentBankSwiftCode: string().nullable().optional().max(200),
  correspondentBankName: string().nullable().optional().max(200),

  bankCountry: object({
    id: string().required(),
    name: string().required(),
  }).required(),

  currency: object({
    value: mixed<CurrencyType>().oneOf(Object.values(CurrencyType)).required(),
    label: string().required(),
  }).required(),
  ownerConfirmationFiles: array()
    .of(localFileScheme.required())
    .required()
    .min(1),
});

export const { Field, Form, useFormContext, Submit } =
  TypedForm<WithdrawalAccountFormType>();
